<template>
  <div :class="{ [`col-md-${md}`]: isPrint, horizontal: isHorizontal }"><slot /></div>
</template>

<script>
export default {
  name: "PrintCol",
  props: {
    isHorizontal: {
      type: Boolean,
      required: false,
      default: false,
    },
    md: {
      type: Number,
      required: false,
      default: 6,
    },
  },
};
</script>
